/* eslint-disable */
const pre = '/dashboard/';

export default {
  path: '/dashboard',
  title: '商城模块',
  header: 'home',
  custom: 'i-icon-demo i-icon-demo-dashboard',
  children: [
    {
      path: `${pre}console`,
      title: '主控台',
    },
    // {
    //     path: `${pre}console1`,
    //     title: '数据分析',
    // },
    // {
    //     path: `${pre}console2`,
    //     title: '官网数据分析',
    // },
    {
      path: `${pre}resource`,
      title: '资源管理',
    },
    // {
    //     path: `${pre}resource1`,
    //     title: '资源管理1',
    // },
    {
      path: `${pre}home-design`,
      title: '首页设置',
    },
    // {
    //     path: `${pre}global-setting`,
    //     title: '全局设置',
    // },
    {
      path: `${pre}notice`,
      title: '通知公告',
    },
    {
      path: `${pre}user`,
      title: '用户管理',
    },
    // {
    //     path: `${pre}shop`,
    //     title: '门店管理',
    // },
    // {
    //     path: `${pre}merchant`,
    //     title: '经销商管理',
    // },
    // {
    //     path: `${pre}merchant_notice`,
    //     title: '经销商通知',
    // },
    // {
    //     path: `${pre}seller`,
    //     title: '代理商管理',
    // },
    {
      path: `${pre}carousel`,
      title: '轮播图管理',
    },
    {
      path: `${pre}shortcuts`,
      title: '快捷栏管理',
    },
    {
      path: `${pre}goods-cate`,
      title: '商品分类管理',
    },
    {
      path: `${pre}goods`,
      title: '商品管理',
    },
    {
      path: `${pre}goods10`,
      title: '新品上架管理',
    },
    {
      path: `${pre}goods20`,
      title: '热门推荐管理',
    },
    {
      path: `${pre}group-buying`,
      title: '团购管理',
    },
    {
      path: `${pre}bargain`,
      title: '砍价管理',
    },
    {
      path: `${pre}seckill`,
      title: '秒杀管理',
    },
    {
      path: `${pre}live`,
      title: '直播管理',
    },
    {
      path: `${pre}order`,
      title: '订单管理',
    },
    {
      path: `${pre}bill`,
      title: '开票管理',
    },
    {
      path: `${pre}salary`,
      title: '工资管理',
    },
    {
      path: `${pre}seckill-order`,
      title: '秒杀订单管理',
    },
    // {
    //     path: `${pre}order1`,
    //     title: '新订单管理',
    // },
    {
      path: `${pre}orderReturn`,
      title: '退货退款管理',
    },
    {
      path: `${pre}order-comment`,
      title: '评论管理',
    },
    {
      path: `${pre}join-us`,
      title: '招聘管理',
    },
    // {
    //   path: `${pre}drp6`,
    //   title: '销售退货',
    // },
    // {
    //   path: `${pre}drp7`,
    //   title: '销售退货明细',
    // },
    {
      path: `${pre}baseSet`,
      title: '商城设置',
    },
    // {
    //     path: `${pre}article-cate`,
    //     title: '文章分类管理',
    // },
    // {
    //     path: `${pre}article`,
    //     title: '文章管理',
    // },
    // {
    //   path: `${pre}integral`,
    //   title: '积分管理',
    // },
    {
      path: `${pre}coupon`,
      title: '优惠券管理',
    },
    // {
    //     path: `${pre}express`,
    //     title: '快递管理',
    // },
    {
      path: `${pre}freight`,
      title: '运费模板管理',
    },
    // {
    //     path: `${pre}exam`,
    //     title: '考试管理',
    // },
    // {
    //     path: `${pre}question`,
    //     title: '题库管理',
    // },
    // {
    //     path: `${pre}study-record`,
    //     title: '学习记录',
    // },
    // {
    //     path: `${pre}study-record1`,
    //     title: '全局学习统计',
    // },
    // {
    //     path: `${pre}pickup`,
    //     title: '自提点管理',
    // },
    // {
    //   path: `${pre}video`,
    //   title: '视频管理',
    // },
    // {
    //   path: `${pre}share-image`,
    //   title: '分享区图片',
    // },
  ],
};
